import React from "react";

export default function Footer() {
    return(
        <div>
            <footer>©2023 #VANLIFE</footer>
        </div>
    )
}